/* eslint-disable @typescript-eslint/no-explicit-any */
import { switchMap, first } from 'rxjs/operators';
import { Actions } from '@ngrx/effects';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Store } from '@ngrx/store';

import { fromCreditBalanceActions, creditBalanceQuery, CreditBalanceState } from '../../+state';

/**
 * Gets CreditBalance for payment-screen
 */
@Injectable()
export class CreditBalanceResolver {
  constructor(
    private _store: Store<CreditBalanceState>,
    private _actions$: Actions
  ) {}

  /*
   * Resolve CreditBalance
   * 1. Selects getCreditBalance from the store
   * 3. Check if credit balance is present
   * - If state is empty:
   *   1. Call getCreditBalance
   * 4. Return balance from store.
   */
  public resolve(): Observable<any> {
    return this._store.select(creditBalanceQuery.getCreditBalance).pipe(
      switchMap(balance => {
        // TODO
        // for now we cannot use cached data
        // there is no delta sync/realtime infrastructure
        this.getCreditBalance();
        return of(balance);

        // if (!balance) {
        //   return this.getCreditBalance();
        // }
        // return of(balance);
      }),
      first()
    );
  }

  /*
   * trigger fetching credit balance
   * 1. Dispatch getCreditBalance action
   * 2. Listening to setCreditBalance
   */
  private getCreditBalance() {
    this._store.dispatch(fromCreditBalanceActions.getCreditBalance());
  }
}
